export default __webpack_public_path__ + "static/media/zrak-doplndilek.0944c15d.svg";